import { render, staticRenderFns } from "./ShowTaskPage.vue?vue&type=template&id=2d77c70c&scoped=true"
import script from "./ShowTaskPage.vue?vue&type=script&lang=js"
export * from "./ShowTaskPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d77c70c",
  null
  
)

export default component.exports